 const Matrix = [
    {
        "Id":1,
        "Topic": "Matrix",
        "Problem": "Spiral traversal on a Matrix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/spirally-traversing-a-matrix/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/spiral-matrix_840698?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":2,
        "Topic": "Matrix",
        "Problem": "Search an element in a matrix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://leetcode.com/problems/search-a-2d-matrix/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/search-in-a-row-wise-and-column-wise-sorted-matrix_839811?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":3,
        "Topic": "Matrix",
        "Problem": "Find median in a row wise sorted matrix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/median-in-a-row-wise-sorted-matrix1527/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/median-in-matrix_981178?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":4,
        "Topic": "Matrix",
        "Problem": "Find row with maximum no. of 1's",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/row-with-max-1s0023/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/row-with-maximum-1-s_1112656?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":5,
        "Topic": "Matrix",
        "Problem": "Print elements in sorted order using row-column wise sorted matrix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/sorted-matrix/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/sorted-matrix_758931?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":6,
        "Topic": "Matrix",
        "Problem": "Maximum size rectangle",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/max-rectangle/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/maximum-size-rectangle-sub-matrix-with-all-1-s_893017?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":7,
        "Topic": "Matrix",
        "Problem": "Find a specific pair in matrix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/find-a-specific-pair-in-matrix/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/find-a-specific-pair-in-the-matrix_1115467?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":8,
        "Topic": "Matrix",
        "Problem": "Rotate matrix by 90 degrees",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/rotate-a-matrix-by-90-degree-in-clockwise-direction-without-using-any-extra-space/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/inplace-rotate-matrix-90-degree_839734?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":9,
        "Topic": "Matrix",
        "Problem": "Kth smallest element in a row-column wise sorted matrix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/kth-element-in-matrix/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/kth-minimum-floor_1115470?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":10,
        "Topic": "Matrix",
        "Problem": "Common elements in all rows of a given matrix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/common-elements-in-all-rows-of-a-given-matrix/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/common-elements-present-in-all-rows-of-a-matrix_1118111?topList=love-babbar-dsa-sheet-problems"
    }
];

export default Matrix;